import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { getLocalLanguage } from "../../common";

export default function StartDate(props) {
    const { t } = useTranslation("translation");
    return (
        <LocalizationProvider id="LocalizationProvider_1" dateAdapter={AdapterDateFns} locale={getLocalLanguage()}>
            <DatePicker
                id="bl_table_DatePicker _12"
                renderInput={(_props) => <TextField {..._props} size="small" />}
                value={props.startDate}
                maxDate={props.maxDate ? props.maxDate : null}
                minDate={props.minDate ? props.minDate : null}
                onChange={props.HandleStartDate}
                inputFormat="dd.MM.yyyy"
                ampm={false}
                label={props.label ? props.label : t("StartDate")}
                margin="normal"
            />
        </LocalizationProvider>
    );
}
